<template>
  <div style="height: 100%">
    <v-slide-x-transition leave-absolute hide-on-leave>
      <div :key="view" class="transition">
        <component v-if="!loading" :is="view"></component>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
import queryString from "query-string";
import ReportProblem from "./ReportProblem.vue";

export default {
  components: {
    ReportProblem
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    var vm = this;
    vm.queryinit();
    vm.init();
  },
  methods: {
    init() {
      var vm = this;
      return new Promise(async (resolve) => {
        // var liffid = "1656921559-eMzV99RQ"; //localhost
        var liffid = "1656921559-X5lmxxv6"; // https://thailandpostmart.zwiz.ai/
        // var liffid = this.$liffid.home;

        if (this.query.apptype == "line") {
          await this.initializeLiff(liffid);
          this.$store.state.userid =
            this.$store.state.profile.userId + "__" + this.query.pageid;
          resolve();
        } else {
          this.$store.state.userid = this.query.userid;
          window.extAsyncInit = function () {
            // the Messenger Extensions JS SDK is done loading
          };
          
          resolve();
          vm.loading = false;
        }
      });
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
          vm.loading = false;
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        // alert(error.message);
      }
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
};
</script>

<style>
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
